(function() {
  var STORAGE_KEY = 'ga4CollectionSelections';
  var MAX_AGE_MS = 30 * 60 * 1000;
  var MAX_RECORDS = 50;
  var modalContexts = new WeakMap();
  var collectionSection = document.getElementById('CollectionSection');
  var currency = (window.theme && theme.settings && theme.settings.cartISOCode) || '';
  var pdpContext = null;
  var lastListSignature = '';
  var viewTimer;

  function pushEvent(name, ecommerce) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({ event: name, ecommerce: ecommerce });
  }

  function readSelections() {
    try {
      var parsed = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
      if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};
      var now = Date.now();
      return Object.fromEntries(Object.entries(parsed).filter(function(entry) {
        var record = entry[1];
        return record && record.productId === entry[0] &&
          typeof record.sourceUrl === 'string' &&
          typeof record.listId === 'string' &&
          typeof record.listName === 'string' &&
          Number.isFinite(record.selectedAt) &&
          now - record.selectedAt >= 0 && now - record.selectedAt <= MAX_AGE_MS;
      }).slice(-MAX_RECORDS));
    } catch (error) {
      return {};
    }
  }

  function saveSelection(context) {
    try {
      var selections = readSelections();
      delete selections[context.productId];
      selections[context.productId] = context;
      var entries = Object.entries(selections).slice(-MAX_RECORDS);
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(Object.fromEntries(entries)));
    } catch (error) {
      return;
    }
  }

  function samePage(first, second) {
    try {
      var a = new URL(first, location.href);
      var b = new URL(second, location.href);
      return a.origin === b.origin && a.pathname === b.pathname && a.search === b.search;
    } catch (error) {
      return false;
    }
  }

  function getList() {
    var section = document.getElementById('CollectionSection');
    if (!section || !section.dataset.ga4CollectionId) return null;
    var grid = section.querySelector('.grid--collection');
    if (!grid) return null;
    return {
      grid: grid,
      id: 'collection_' + section.dataset.ga4CollectionId,
      name: section.dataset.ga4CollectionName || '',
      currency: section.dataset.ga4Currency || currency
    };
  }

  function visibleCards(list) {
    return Array.from(list.grid.children).filter(function(card) {
      return card.dataset.ga4ProductId && card.getClientRects().length > 0;
    });
  }

  function itemFromCard(card, index, list) {
    var data = card.dataset;
    var item = {
      item_id: String(data.ga4ProductId),
      item_name: data.ga4ProductName || '',
      item_list_id: list.id,
      item_list_name: list.name,
      index: index,
      quantity: 1
    };
    if (data.ga4ProductBrand) item.item_brand = data.ga4ProductBrand;
    if (data.ga4ProductCategory) item.item_category = data.ga4ProductCategory;
    if (data.ga4VariantName && data.ga4VariantName !== 'Default Title') item.item_variant = data.ga4VariantName;
    var cents = Number(data.ga4PriceCents);
    if (data.ga4PriceCents !== '' && Number.isFinite(cents) && cents >= 0) item.price = cents / 100;
    return item;
  }

  function emitListView() {
    var list = getList();
    if (!list) return;
    var cards = visibleCards(list);
    if (!cards.length) return;
    var signature = location.pathname + location.search + '|' + list.id + '|' +
      cards.map(function(card) { return card.dataset.ga4ProductId; }).join(',');
    if (signature === lastListSignature) return;
    lastListSignature = signature;
    pushEvent('collection_view_item_list', {
      currency: list.currency,
      item_list_id: list.id,
      item_list_name: list.name,
      items: cards.slice(0, 200).map(function(card, index) {
        return itemFromCard(card, index, list);
      })
    });
  }

  function scheduleListView() {
    clearTimeout(viewTimer);
    viewTimer = setTimeout(emitListView, 100);
  }

  function selectFromCard(event) {
    var list = getList();
    if (!list || !(event.target instanceof Element)) return;
    var card = event.target.closest('[data-ga4-product-id]');
    if (!card || !list.grid.contains(card)) return;
    var quickButton = event.target.closest('.quick-product__btn');
    var link = event.target.closest('a[href]');
    if (!quickButton && (!link || !new URL(link.href, location.href).pathname.includes('/products/'))) return;
    var cards = visibleCards(list);
    var index = cards.indexOf(card);
    if (index < 0) return;
    var item = itemFromCard(card, index, list);
    var context = {
      productId: item.item_id,
      listId: list.id,
      listName: list.name,
      index: index,
      sourceUrl: location.href,
      selectedAt: Date.now()
    };
    saveSelection(context);
    if (quickButton) {
      var modal = document.getElementById('QuickShopModal-' + item.item_id);
      if (modal) modalContexts.set(modal, context);
    }
    pushEvent('collection_select_item', {
      currency: list.currency,
      item_list_id: list.id,
      item_list_name: list.name,
      items: [item]
    });
  }

  function getPdpContext() {
    if (collectionSection) return null;
    var product = document.querySelector('.product-section[data-ga4-product-id]');
    if (!product) return null;
    var context = readSelections()[product.dataset.ga4ProductId];
    if (!context) return null;
    var marker = history.state && history.state.ga4CollectionSelection;
    if (marker && marker.productId === context.productId && marker.selectedAt === context.selectedAt) return context;
    if (!samePage(document.referrer, context.sourceUrl)) return null;
    if (history.replaceState) {
      try {
        history.replaceState(Object.assign({}, history.state, {
          ga4CollectionSelection: { productId: context.productId, selectedAt: context.selectedAt }
        }), '', location.href);
      } catch (error) {
        return context;
      }
    }
    return context;
  }

  function addedItems(detail) {
    var response = detail.response;
    if (!response) return [];
    if (Array.isArray(response.items)) return response.items;
    if (Array.isArray(response)) return response;
    return [response];
  }

  function onCartAddSuccess(event) {
    var detail = event.detail || {};
    var lines = addedItems(detail);
    if (!lines.length) return;
    var form = detail.form;
    var modal = form && form.closest('.modal--quick-shop');
    var context = modal ? modalContexts.get(modal) : form ? pdpContext : null;
    var items = lines.map(function(line, index) {
      var submitted = detail.items && detail.items[index];
      var section = form && form.closest('.product-section');
      var productId = line.product_id || (section && section.dataset.ga4ProductId);
      var quantity = Number(line.quantity || (submitted && submitted.quantity) || 1);
      var cents = Number(line.price);
      var item = {
        item_name: line.product_title || line.title || '',
        quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1
      };
      if (productId) item.item_id = String(productId);
      if (line.vendor) item.item_brand = line.vendor;
      if (line.product_type) item.item_category = line.product_type;
      if (line.variant_title && line.variant_title !== 'Default Title') item.item_variant = line.variant_title;
      if (line.price !== undefined && line.price !== null && line.price !== '' && Number.isFinite(cents) && cents >= 0) item.price = cents / 100;
      if (context && item.item_id === context.productId) {
        item.item_list_id = context.listId;
        item.item_list_name = context.listName;
        item.index = context.index;
      }
      return item;
    });
    var ecommerce = { currency: currency, items: items };
    var firstItem = items[0];
    if (firstItem.item_list_id && firstItem.item_list_name && items.every(function(item) {
      return item.item_list_id === firstItem.item_list_id && item.item_list_name === firstItem.item_list_name;
    })) {
      ecommerce.item_list_id = firstItem.item_list_id;
      ecommerce.item_list_name = firstItem.item_list_name;
    }
    if (items.every(function(item) { return Number.isFinite(item.price); })) {
      ecommerce.value = items.reduce(function(total, item) {
        return total + item.price * item.quantity;
      }, 0);
    }
    pushEvent('collection_add_to_cart', ecommerce);
  }

  document.addEventListener('theme:cart:add:success', onCartAddSuccess);

  function init() {
    pdpContext = getPdpContext();
    if (!collectionSection) return;
    document.addEventListener('click', selectFromCard, true);
    var container = document.getElementById('CollectionAjaxResult') || collectionSection;
    new MutationObserver(scheduleListView).observe(container, { childList: true, subtree: true });
    scheduleListView();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
